/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum PolicySecuritySubClassification {
    Access = 'Access',
    Application = 'Application',
    Application_Integration = 'Application_Integration',
    Availability = 'Availability',
    Data = 'Data',
    Databases = 'Databases',
    Encryption = 'Encryption',
    End_Point_Protection = 'End Point Protection',
    High = 'High',
    Host = 'Host',
    Identity = 'Identity',
    Logging = 'Logging',
    Monitoring = 'Monitoring',
    Network = 'Network',
    SNS = 'SNS',
    Standards = 'Standards',
    Storage = 'Storage',
    medium = 'medium'
}
